import React from 'react';

const ListViewFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M4 4h16v4H4zM4 10h16v4H4zM4 16h16v4H4z" />
        </g>
    </svg>
);

ListViewFillSvg.displayName = 'ListViewFillSvg';
export default ListViewFillSvg;
